<template>
  <span>
    <el-button type="primary" @click="$refs.upload.click()">本地图片</el-button>&nbsp;&nbsp;&nbsp;
    <input
      type="file"
      accept="image/*"
      ref="upload"
      :multiple="multiple"
      @change="emitSelect($event.target.files); $event.target.value=null;"
      style="display:none;"
    >
    <el-button type="primary" @click="presetVisible = true">使用预置图片</el-button>
    <el-dialog :visible.sync="presetVisible" title="选择预置图片" @close="images.forEach(e => e.active = false)" append-to-body>
      <div style="display: flex;flex-direction: column;align-items: center;">
        <div v-for="e of images" :key="e.id">
          <img
            ref="preset"
            :key="e.src"
            :class="{ active: e.active }"
            :src="e.src"
            :attr-img="e"
            @click="presetSelect(e)">
        </div>
      </div>
      <span slot="footer">
        <el-button @click="presetVisible = false">取 消</el-button>
        <el-button @click="presetConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>
<script>
import cat from "../assets/cat.jpg";
import lenna from "../assets/1.jpg";
import barbara from "../assets/3.png";

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      presetVisible: false,
      images: [
        { src: cat, mimeType: "image/jpeg", name: "cat.jpg", active: false },
        { src: lenna, mimeType: "image/jpeg", name: "lenna.jpg", active: false },
        {
          src: barbara,
          mimeType: "image/png",
          name: "barbara.png",
          active: false
        }
      ]
    };
  },
  methods: {
    emitSelect(files) {
      if (files.length === 0) {
        return;
      }

      this.$emit("select", [...files]);
    },

    presetSelect(image) {
      image.active = !image.active;
      if (!this.multiple) {
        this.images.filter(e => e !== image).forEach(e => (e.active = false));
      }
    },

    presetConfirm() {
      //将选中的图片转化成文件
      const createFile = (el, image) => {
        return new Promise((resolve, reject) => {
          let cav = document.createElement("canvas");
          cav.width = el.width;
          cav.height = el.height;
          cav.getContext("2d").drawImage(el, 0, 0);
          cav.toBlob(blob => {
            resolve(new File([blob], image.name, { type: blob.type }));
          }, image.mimeType);
        });
      };
      let tasks = [];
      for (let i = 0; i < this.images.length; i++) {
        if (!this.images[i].active) {
          continue;
        }
        tasks.push(createFile(this.$refs.preset[i], this.images[i]));
      }
      Promise.all(tasks).then(res => {
        this.presetVisible = false;
        this.emitSelect(res);
      });
    }
  }
};
</script>
<style scoped>
img.active {
  border: 2px red solid;
}
</style>

